export default __webpack_public_path__ + "static/media/HeroHeaderiPhone13ProMax.80cc0194.jpeg";